// extracted by mini-css-extract-plugin
module.exports = {"two-grid":"styles-m__two-grid__1DKeZ","ul-list":"styles-m__ul-list__3M5if"};